<script>
export default {
  name: 'SenioridadeNewUx',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#030309',
    },
  },
  computed: {
    // ID único por instância (this._uid é garantido único por componente Vue) —
    // o id fixo original (copiado de export do Figma) colide quando o mesmo
    // ícone renderiza mais de uma vez na mesma página.
    clipId() {
      return `clip0_5172_133006_${this._uid}`
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="6" y="6" width="11" height="11" :fill="color" />
    <path
      d="M18.5408 4.17001L13.0408 2.11001C12.4708 1.90001 11.5408 1.90001 10.9708 2.11001L5.47078 4.17001C4.41078 4.57001 3.55078 5.81001 3.55078 6.94001V15.04C3.55078 15.85 4.08078 16.92 4.73078 17.4L10.2308 21.51C11.2008 22.24 12.7908 22.24 13.7608 21.51L19.2608 17.4C19.9108 16.91 20.4408 15.85 20.4408 15.04V6.94001C20.4508 5.81001 19.5908 4.57001 18.5408 4.17001ZM12.0008 16.25C9.38078 16.25 7.25078 14.12 7.25078 11.5C7.25078 8.88001 9.38078 6.75001 12.0008 6.75001C14.6208 6.75001 16.7508 8.88001 16.7508 11.5C16.7508 14.12 14.6208 16.25 12.0008 16.25Z"
      :fill="color"
    />
    <g :clip-path="`url(#${clipId})`">
      <path
        d="M12 15.25V15.69C12 16.625 11.625 17 10.685 17H8.31C7.585 17 7 16.415 7 15.69V13.315C7 12.375 7.375 12 8.31 12H8.75V13.75C8.75 14.58 9.42 15.25 10.25 15.25H12Z"
        fill="white"
      />
      <path
        d="M14.5 12.75V13.185C14.5 13.91 13.91 14.5 13.185 14.5H10.81C9.875 14.5 9.5 14.125 9.5 13.185V10.81C9.5 10.085 10.085 9.5 10.81 9.5H11.25V11.25C11.25 12.08 11.92 12.75 12.75 12.75H14.5Z"
        fill="white"
      />
      <path
        d="M17 8.31V10.685C17 11.625 16.625 12 15.685 12H13.31C12.375 12 12 11.625 12 10.685V8.31C12 7.375 12.375 7 13.31 7H15.685C16.625 7 17 7.375 17 8.31Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath :id="clipId">
        <rect width="10" height="10" fill="white" transform="translate(7 7)" />
      </clipPath>
    </defs>
  </svg>
</template>
